import axiosInstance from '../lib/axios.config';
import { LOCATION } from '../constants/api-endpoints';
import type { Country, State } from '../types/user.types';

interface CountriesResponse {
  message: string;
  data: Country[];
  error: null | string;
}

interface StatesResponse {
  message: string;
  data: State[];
  error: null | string;
}

export const locationService = {
  getCountries: async (): Promise<Country[]> => {
    const response = await axiosInstance.get<CountriesResponse>(
      LOCATION.COUNTRIES
    );
    return response.data.data;
  },

  getStatesByCountryCode: async (countryCode: string): Promise<State[]> => {
    const response = await axiosInstance.get<StatesResponse>(
      LOCATION.STATES_BY_CODE(encodeURIComponent(countryCode))
    );
    return response.data.data;
  },
};
